
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AddProjectDialog from './components/projectDialog.vue';
import AddProjectTaskDialog from './components/projectTaskDialog.vue';
import ProjectDetailsDialog from './components/projectDetailsDialog.vue';
import { getAllProjectList, getProjectTaskCollect, delProject, startProject, startProjectTask, delProjectTask, completeProject, completeProjectTask } from '@/api/project';

import { UserModule } from '@/store/modules/user';

@Component({
  name: 'ProjectMy',
  components: {
    AddProjectDialog,
    AddProjectTaskDialog,
    ProjectDetailsDialog
  }
})
export default class extends Vue {
  private tableData: any = []
  private editData:any={}
  private dialogAddProjectVisible = false;

  private formSearch:any={}
  private stateList:any=[
    {
      id: '0',
      name: '未开始'
    },
    {
      id: '1',
      name: '开始'
    },
    {
      id: '2',
      name: '结束'
    }
  ]

  private projectAlias=(UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目')
  private projectTaskAlias=(UserModule.getCompany.project_task_alias ? UserModule.getCompany.project_task_alias : '任务')
  private projectTaskCollectAlias=(UserModule.getCompany.project_task_collect_alias ? UserModule.getCompany.project_task_collect_alias : '任务集')

  // 页码处理
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private getAddShow(val:any) {
    let show = false;
    if (parseInt(val.is_project) === 1) {
      show = parseInt(val.is_operation) === 1 && parseInt(val.state) !== 2;
    } else {
      show = parseInt(val.is_task_collect) === 1 && parseInt(val.is_operation) === 1 && parseInt(val.state) !== 2;
    }
    return show;
  }
  private getDelShow(val:any) {
    if(val.is_project ==1){
      //仅项目开放  is_operation == 1 || create_user_id == user_id 
      let show = parseInt(val.create_user_id) == UserModule.getUserId || parseInt(val.is_operation) === 1;
      return show;
    }else{
      // 赵子龙说文档这样写的
      let show = parseInt(val.state) !== 1 && parseInt(val.is_operation) === 1;
      return show;
    }
  }
  private getEditShow(val:any) {
    let show = false;
    if (parseInt(val.is_project) === 1) {
      show = parseInt(val.state) === 0 && parseInt(val.is_operation) === 1;
    } else {
      show = parseInt(val.state) === 0 && parseInt(val.is_operation) === 1 && parseInt(val.project_state) === 0;
    }
    return show;
  }
  private getStartShow(val:any) {
    let show = false;
    if (parseInt(val.is_project) === 1) {
      show = parseInt(val.is_operation) === 1 && parseInt(val.state) === 0;
    } else {
      show = parseInt(val.is_operation) === 1 && parseInt(val.is_start_operation) === 1 && parseInt(val.state) === 0;
    }
    return show;
  }
  private getRestStartShow(val:any) {
    let show = false;
    if (parseInt(val.is_project) === 1) {
      show = false;
    } else {
      show = parseInt(val.is_reset_start_operation) === 1;
    }
    return show;
  }
  private getEndShow(val:any) {
    let show = false;
    if (parseInt(val.is_project) === 1) {
      show = parseInt(val.is_operation) === 1 && parseInt(val.state) === 1;
    } else {
      show = parseInt(val.is_operation) === 1 && parseInt(val.state) === 1;
    }
    return show;
  }

  created() {
    this.getList();
  }
  private maps:any = new Map();
  private load(tree: any, treeNode: any, resolve: any) {
    if (parseInt(tree.is_project) === 1) {
      this.getTaskList(tree.id, '', tree, resolve);
      this.maps.set('-1', { tree, treeNode, resolve });
    } else {
      this.maps.set(tree.id, { tree, treeNode, resolve });
      this.getTaskList(tree.project_id, tree.id, tree, resolve);
    }
  }
  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }
  private handleClear() {
    this.formSearch = {}
    this.pagination.currentPage = 1;
    this.getList();
  }
  private getList() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    pamars.name = this.formSearch.name;
    if (this.formSearch.state) {
      pamars.state = this.formSearch.state
    }

    getAllProjectList(pamars).then((res:any) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
        this.tableData.forEach((item:any) => {
          item.hasChildren = parseInt(item.child_number) > 0;
          item.onlyId = 'p' + item.id;
        });
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;

      this.tableData = [];
    });
  }
  private getTaskList(projectId:string, projectTaskId:string, tree:any, resolve:any) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = projectId;
    pamars.project_task_id = projectTaskId;
    pamars.size = 999;
    pamars.is_pass_task = 1;
    getProjectTaskCollect(pamars).then((res:any) => {
      if (res.data) {
        let dataTable:any = res.data.list;
        tree.children = dataTable;
        dataTable.forEach((item:any) => {
          item.hasChildren = parseInt(item.child_number) > 0;
          item.onlyId = item.id;
        });
        resolve(dataTable);
      } else {
        resolve([]);
      }
    }).catch(err => {
      let msg = err.msg;
      resolve([]);
    });
  }

  private handleProjectAdd(val:any) {
    this.dialogAddProjectVisible = true;
  }
  private closeAddProjectDialog(val:boolean) {
    this.dialogAddProjectVisible = false;
  }
  private finishAdd() {
    this.dialogAddProjectVisible = false;
    this.getList();
  }

  private edit(val:any) {
    if (parseInt(val.is_project) === 1) {
      this.editData = val;
      this.dialogAddProjectVisible = true;
    } else {
      this.editData = val;
      this.taskType = 2;
      this.dialogAddProjectTaskVisible = true;
    }
  }
  private del(val:any) {
    if (parseInt(val.is_project) === 1) {
      let that = this;
      this.$confirm('是否删除?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pamars:any = {};
          pamars.user_id = UserModule.getUserId;
          pamars.user_name = UserModule.getUserName;
          pamars.company_id = UserModule.getCompanyId;
          pamars.project_id = val.id;
          delProject(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            that.getList();
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        });
    } else {
      let that = this;
      this.$confirm('是否删除?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pamars:any = {};
          pamars.user_id = UserModule.getUserId;
          pamars.user_name = UserModule.getUserName;
          pamars.company_id = UserModule.getCompanyId;
          pamars.project_id = val.project_id;
          pamars.project_task_id = val.id;
          delProjectTask(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            if (val.pids) {
              this.refDataList(val.pids, val.hasChildren);
            } else {
              this.refDataList('-1', val.hasChildren);
            }
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        });
    }
  }
  private start(val:any, isResetStart:boolean) {
    if (parseInt(val.is_project) === 1) {
      let that = this;
      this.$confirm('是否开始' + this.projectAlias + '?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pamars:any = {};
          pamars.user_id = UserModule.getUserId;
          pamars.user_name = UserModule.getUserName;
          pamars.company_id = UserModule.getCompanyId;
          pamars.project_id = val.id;
          startProject(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            that.getList();
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        });
    } else {
      let title = this.projectTaskCollectAlias;
      if (parseInt(val.is_task_collect) === 1) {
        title = this.projectTaskCollectAlias;
      } else {
        title = this.projectTaskAlias;
      }

      let that = this;
      this.$confirm('是否' + (isResetStart ? '重新' : '') + '开始' + title + '?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pamars:any = {};
          pamars.user_id = UserModule.getUserId;
          pamars.user_name = UserModule.getUserName;
          pamars.company_id = UserModule.getCompanyId;
          pamars.project_id = val.project_id;
          pamars.project_task_id = val.id;
          if (isResetStart) {
            pamars.is_reset_start = 1;
          }
          startProjectTask(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            if (val.pids) {
              this.refDataList(val.pids, val.hasChildren);
            } else {
              this.refDataList('-1', val.hasChildren);
            }
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        });
    }
  }
  private end(val:any) {
    if (parseInt(val.is_project) === 1) {
      let that = this;
      this.$confirm('是否结束' + this.projectAlias + '?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pamars:any = {};
          pamars.user_id = UserModule.getUserId;
          pamars.user_name = UserModule.getUserName;
          pamars.company_id = UserModule.getCompanyId;
          pamars.project_id = val.id;
          completeProject(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            that.getList();
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        });
    } else {
      let title = this.projectTaskCollectAlias;
      if (parseInt(val.is_task_collect) === 1) {
        title = this.projectTaskCollectAlias;
      } else {
        title = this.projectTaskAlias;
      }

      let that = this;
      this.$confirm('是否结束' + title + '?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pamars:any = {};
          pamars.user_id = UserModule.getUserId;
          pamars.user_name = UserModule.getUserName;
          pamars.company_id = UserModule.getCompanyId;
          pamars.project_id = val.project_id;
          pamars.project_task_id = val.id;
          completeProjectTask(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            if (val.pids) {
              this.refDataList(val.pids, val.hasChildren);
            } else {
              this.refDataList('-1', val.hasChildren);
            }
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        });
    }
  }

  private dialogProjectDetailsVisible= false // 详情
  private projectDetails:any = ''
  private handleDetail(val:any) {
    this.projectDetails = val;
    this.dialogProjectDetailsVisible = true;
  }
  private closeProjectDetails(val: any) {
    this.dialogProjectDetailsVisible = val;
  }

  private dialogAddProjectTaskVisible = false // 添加任务
  private taskType=1;
  private handleTaskAdd(val:any) {
    this.editData = val;
    this.taskType = 1;
    this.dialogAddProjectTaskVisible = true;
  }
  private finishAddTask() {
    if (parseInt(this.editData.is_project) === 1) {
      this.getList();
      this.refDataList('-1', this.editData.hasChildren);
    } else {
      if (this.editData.pids) {
        this.refDataList(this.editData.pids, this.editData.hasChildren);
      } else {
        this.refDataList('-1', this.editData.hasChildren);
      }
    }
  }
  private closeAddProjectTask(val: any) {
    this.dialogAddProjectTaskVisible = val;
  }

  private handleFileAdd(val: any) {
    // 追加资料
    this.projectDetails = val;
    this.dialogProjectDetailsVisible = true;
  }

  private refDataList(pids:any, hasChildren:boolean) {
    let list = pids.split(',');
    let _ = this;
    if (list) {
      if (hasChildren) {
        _.refData(list[list.length - 1]);
      } else {
        _.refData(list[list.length - 1]);
        _.refData(list[list.length - 2]);
      }
    }
  }
  private refData(pid:any) {
    if (parseInt(pid) === -1) {
      this.maps.forEach((item:any) => {
        this.$set(((this.$refs.tableList) as any).store.states.lazyTreeNodeMap, item.tree.onlyId, []);
        this.load(item.tree, item.treeNode, item.resolve);
      });
    } else {
      if (this.maps.get(pid)) {
        this.$set(((this.$refs.tableList) as any).store.states.lazyTreeNodeMap, pid, []);
        const { tree, treeNode, resolve } = this.maps.get(pid);
        this.load(tree, treeNode, resolve);
      }
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
